import {SET_PERMISSIONS, SET_USER, USER_LOGOUT} from "../Actions/Types/userActionTypes";
import {VERIFICATION_CANCEL} from "../Actions/Types/loginActionTypes";

const initialState = {
    user: null,
    permissions: [],
};

export const userReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_USER:
            return {
                ...state,
                user: action.user,
            };
        case SET_PERMISSIONS:
            return {
                ...state,
                permissions: action.permissions,
            };
        case VERIFICATION_CANCEL:
        case USER_LOGOUT:
            return initialState;
        default:
            return state;
    }
};


